export default {
  setUser(state, payload) {
    state.token = payload.token;
    state.userId = payload.userId;
    state.userType = payload.userType;
  },
  setAutoLogout(state) {
    state.didAutoLogout = true;
  }
};
